const translations = {
    invoiceManagement: "ניהול חשבוניות",
    confirmDeletion: "אישור מחיקה",
    deleteConfirmation: "האם אתה בטוח שברצונך למחוק חשבונית זו?",
    cancel: "ביטול",
    actions: "פעולות",
    delete: "מחק",
    download: "הורדה",
    id: "מס' חשבונית",
    supplierName: "שם ספק",
    date: "תאריך החשבונית",
    amount: "סכום",
    amountBeforeVat: "סכום לפני מע\"מ",
    status: "סטטוס",
    approver: "מאשר",
    uploadedAt: "תאריך קליטה במערכת",
    oldInvoiceDate: "תאריך החשבונית (חשבונית ישנה)",
    oldInvoiceShort: "ישנה",
    approvalPackage: "אישור",
    uploadedInvoices: "חשבוניות שהועלו",
    invoicesByStatus: "חשבוניות לפי סטטוס",
    uploadInvoices: "העלה חשבוניות",
    dragAndDropPrompt: "גרירת קבצים לכאן או לחיצה לבחירה",
    pendingFiles: "קבצים ממתינים להעלאה",
    uploading: "מעלה...",
    uploadToServer: "העלה לשרת",
    uploadSuccess: "הקבצים הועלו בהצלחה",
    uploadError: "שגיאה בהעלאת הקבצים",
    successfullyUploadedFiles: "קבצים שהועלו בהצלחה",
    supportedFormats: "PDF, JPEG, או PNG"
  };
  
  export default translations;